import { render, staticRenderFns } from "./IconUnauthorizedIgnition.vue?vue&type=template&id=39b3cbfd"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports